import { checkStatus } from './cp-analytics-reporter-middleware';
import { HTTPMethod, ContentTypes } from './request';
/**
 * Middleware for automatically reporting redux actions to [Marquee Metrics][https://dash.web.gs.com/documents/devtools/documentation/marquee-components/MarqueeMetrics.html]
 * @example Setup
 * import { buildMetricsLogger } from '@mq/aurora-redux-middleware';
 * const mmReporter = buildMetricsLogger({
 * appId: 'your-APPDIR-App-id',
 * shouldLog: (action) => !(/^(?:RECV|XHR_ERROR)/).test(action.type)
 * });
 * const middleware = applyMiddleware(thunkMiddleware, callAPIMiddleware, mmReporter, ...);
 */
// @ts-ignore - Need to fix the strictFunctionTypes here that was added in Typescript 2.6 [MQAURORA-901]
var buildLogger = function (config) {
  var appId = config.appId,
    _a = config.shouldLog,
    shouldLog = _a === void 0 ? function (action) {
      return true;
    } : _a,
    _b = config.getUrl,
    getUrl = _b === void 0 ? function () {
      return '/metrics/v1/browser_event';
    } : _b,
    _c = config.getPayload,
    getPayload = _c === void 0 ? function (action) {
      return {
        location: window.location.toString(),
        section: window.location.pathname,
        action: action.type,
        subSection: '',
        asset: ''
      };
    } : _c,
    _d = config.fetch,
    fetch = _d === void 0 ? window.fetch : _d;
  if (!appId) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }
  var headers = {
    Accept: ContentTypes.JSON,
    'Content-Type': ContentTypes.JSON + ";charset=utf-8",
    'X-Dash-AppId': appId
  };
  var url = getUrl();
  return function () {
    return function (next) {
      return function (action) {
        if (shouldLog(action)) {
          var payload = getPayload(action);
          var opts = {
            method: HTTPMethod.POST,
            credentials: 'same-origin',
            headers: headers,
            body: JSON.stringify(payload)
          };
          fetch(url, opts).then(checkStatus).then(null, function (err) {
            // tslint:disable-next-line: no-console
            console.error('POST to Marquee metrics failed', err);
          });
        }
        return next(action);
      };
    };
  };
};
export { buildLogger };